// extracted by mini-css-extract-plugin
export var searchHeader = "_6s-0";
export var searchHeaderDark = "_6s-1";